import { Pipe, PipeTransform } from '@angular/core';
import {LczEventDate} from "./lcz-data.service";

@Pipe({
  name: 'lczDatum'
})
export class LczDatumPipe implements PipeTransform {

  transform(value: LczEventDate, args?: any): string {

    const monate = [
      '',
      'Januar',
      'Februar',
      'März',
      'April',
      'Mai',
      'Juni',
      'Juli',
      'August',
      'September',
      'October',
      'November',
      'December'
    ];
    let string = '';
    if (value) {
      if (value.day) {
        string += value.day + '.';
      }
      if (value.month) {
        string += ' ' + monate[value.month];
      }
      if (value.year) {
        string += ' ' + value.year;
      }
    }

    return string;
  }

}
